<template>

    <form @submit.prevent="fnSubmitData" ref="frmcategories">

      <div class="filtercategoriescontainer"  v-if="isloading==false" >
            <label class="categoriescontainer" v-bind:class="{selectedcategory:currentfiltercategory==''}"   >{{ allprojects }}
              <input type="radio" name="currentfiltercategory" value=""  v-model="$store.state.currentfiltercategory" @click="currentfiltercategory=''" @input="fnSubmitData" >
              <!--<span class="checkmark"></span>-->
            </label>
             
            <label v-for="category in categories" :key="category.key"  class="categoriescontainer" v-bind:class="{selectedcategory:currentfiltercategory==category.key}"  @mouseenter="fnSetCurrentHoverCategory(category.key)"   @mouseleave="fnSetCurrentHoverCategory('')" @mouseup="fnSetCurrentHoverCategory('');"  >
              <input v-if="category.key!='news'" type="radio"  name="currentfiltercategory" :value="category.key" v-model="$store.state.currentfiltercategory" @click="currentfiltercategory=category.key"  @input="fnSubmitData">
              <span v-if="category.key!='news'" >{{category.title}}</span>
              <!--<span  v-if="currenthovercategory==category.key" >&nbsp;-&nbsp;{{category.slogan}}</span>-->
            </label>
      </div>
     <!-- <button>test</button>  -->
 
    </form>
    <img class="loadingcategories" src="@/assets/images/loading.gif"  v-if="isloading==true"/>
    
    

</template>

<script>
import multilangmixin from "../mixins/multilangmixin.js"
import backendmixin from "../mixins/backendmixin.js"


// eslint-disable-next-line no-unused-vars 

export default {
  name: "cmpfiltercategory",
  mixins:[multilangmixin,backendmixin],
  emits:["sigfilterchanged"],
  
  props:["initialfiltercategory"],


  data(){
      return {
                
                "currenthovercategory":"",
            };
  },


  created(){
     
     
      this.fnInitFromQueryString();
      this.fnFetchCategories();
  },

  computed:{
      allprojects(){
        return this.fnGetTranslation(this.currentlang,"allprojects");
      },


      currentfiltercategory:{
        get(){
          return this.$store.state.currentfiltercategory;
        },
        set(newvalue){
          this.$store.commit("fnSetCurrentFilterCategory",newvalue);
        }
      
      }


  },


  methods:{


/*
        fnSubmitFormProgrammatically()
        {
          this.$refs.frmcategories.submit();
        },
*/
       
        fnOnSigCategoriesReady()
        {
          console.log("ready cat");
        },

        fnSetCurrentHoverCategory(piKey)
        {
          this.currenthovercategory=piKey;

        },



        fnSubmitData(){

          //this.$refs.myForm.submit();

          this.$emit("sigfilterchanged");
              
        },

        fnInitFromQueryString()
        {
          let wCategory=this.fnGetQueryParam("category");
          if (wCategory!=undefined)
          {
            
              this.currentfiltercategory=wCategory;
          }
          //console.log(this.currentfiltercategory);
          
          
        }


  }
 
  

}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
      
  .filtercategoriescontainer{
    /*background-color: gray;*/
    font-weight: bold;
    font-size: 1.5em; 
    width: fit-content;
  }


  /* The container */
  .categoriescontainer {
    display: block;
    position: relative;
    margin-bottom: 0.6vh;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    
  }


 .categoriescontainer:hover{
    text-decoration: none;
    color: #ffdd00;
    
  }


  .selectedcategory{
    text-decoration: none;
    color:#ffdd00;
   
  }


  /*
  versione sottolineato
  .selectedcategory{
    text-decoration: underline;
    text-decoration-color: #ffdd00;
    text-decoration-style: solid;
    text-decoration-thickness: 0.2em;    
  }
  */

  /* Hide the browser's default radio button */
  .categoriescontainer input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }

  .slogancategorie
  {
    color: #ffdd00;
    text-decoration: none;
    
  }
 
  .loadingcategories
  {
    
    width: 3vh;
    height: 3vh;
    margin: auto;
    
  }


  @media screen and (min-width: 700px)    {
      /*  schermo desktop */
    
      /*
      .filtercategoriescontainer{
        width: 270px;
      }
      */

  }
  
  @media screen and (max-width: 700px) {
     /*  schermo mobile */
  
      
 
  }


</style>
